import * as React from 'react';
import type { PiletApi } from '@chess/platform-web';
import { Layout, LayoutParams, setTabClick, useTabs } from './Layout';
import type { SelectTabEvent, TabBadgeEvent, TabsHiddenEvent } from './events';
import './layout.css';

// The layout plugin provides named layouts. A screen renders the `layout`
// extension with the layout's name and a binding from its own slots to the
// layout's regions. Panels contribute to the screen's slots and never see a
// region name.
export function setup(app: PiletApi) {
  app.registerExtension<LayoutParams>('layout', ({ params }) => <Layout {...params} Extension={app.Extension} />);
  // Any plugin may ask for a badge after a tab's title, such as a stage's score, through an event.
  app.on('layout.tabBadge', (event: TabBadgeEvent) => useTabs.getState().badge(event.slot, event.id, event.badge, event.tone));
  // Another plugin may ask a tabbed region to show one of its tabs.
  app.on('layout.selectTab', (event: SelectTabEvent) => useTabs.getState().select(event.slot, event.id));
  // Another plugin may hide a tabbed region for a while (the stage tabs under a puzzle); the selection stays.
  app.on('layout.tabsHidden', (event: TabsHiddenEvent) => useTabs.getState().setHidden(event.slot, event.hidden));
  // A reader's click on a tab, distinct from a tab selected by an event; fired
  // even when the tab is already active.
  setTabClick((slot, id) => app.emit('layout.tabClick', { slot, id }));
}
